import ModalVideo from 'modal-video';

export default () => {

  const videos = document.querySelectorAll('.carousel-slide-video');

  if (videos.length) {

    videos.forEach((video) => {

      if (video.classList.contains('youtube') || video.classList.contains('vimeo')) {
        const link = video.getAttribute('data-video-id'),
              start = link.lastIndexOf('/') + 1;

        video.setAttribute('data-video-id', link.substring(start));
      } else {
        // if it's a wistia link, update the iframe src
        video.addEventListener('click', (e) => {
          e.preventDefault();
          const url = e.currentTarget.getAttribute('data-video-id');
          setTimeout(() => {
            const iframe = document.querySelector('.modal-video iframe');
            iframe.setAttribute('src', url);
          }, 200);
        });
      }
    });

    new ModalVideo('.carousel-slide-video.vimeo', { channel: 'vimeo' });
    new ModalVideo('.carousel-slide-video.youtube', { channel: 'youtube' });
    new ModalVideo('.carousel-slide-video.wistia', { channel: 'youtube' });
    new ModalVideo('.carousel-slide-video.kuula', { channel: 'youtube' });
  }
};
